module.exports = __webpack_public_path__ + "assets/img/0_03.65cacf84.png";